module.exports = __webpack_public_path__ + "img/sub2.cabf3666.jpg";